import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountConfig } from '@shared/products-feature-configs';

import { settingsDetails } from '../settings-details-config/CZ';
import { statements } from '../statements-config/CZ';

export const currentAccount: DeepPartial<CurrentAccountConfig> = {
    statements,
    roundingSavings: {
        enabled: false,
    },
    sepaMandatesRead: {
        enabled: false,
    },
    accountAddress: {
        enabled: false,
    },
    standingOrderDispoModel: true,
    settingsDetails,
    layout: {
        productInfo: {
            showDisposableAndBalanceAmounts: true,
        },
    },
};
